export enum countryCode {
  US = 'US',
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SG = 'SG',
  SX = 'SX',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  GB = 'GB',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW'
}

export const countryCodeToNameMap = {
  [countryCode.US]: 'United States of America',
  [countryCode.AF]: 'Afghanistan',
  [countryCode.AX]: 'Åland Islands',
  [countryCode.AL]: 'Albania',
  [countryCode.DZ]: 'Algeria',
  [countryCode.AS]: 'American Samoa',
  [countryCode.AD]: 'Andorra',
  [countryCode.AO]: 'Angola',
  [countryCode.AI]: 'Anguilla',
  [countryCode.AQ]: 'Antarctica',
  [countryCode.AG]: 'Antigua and Barbuda',
  [countryCode.AR]: 'Argentina',
  [countryCode.AM]: 'Armenia',
  [countryCode.AW]: 'Aruba',
  [countryCode.AU]: 'Australia',
  [countryCode.AT]: 'Austria',
  [countryCode.AZ]: 'Azerbaijan',
  [countryCode.BS]: 'Bahamas',
  [countryCode.BH]: 'Bahrain',
  [countryCode.BD]: 'Bangladesh',
  [countryCode.BB]: 'Barbados',
  [countryCode.BY]: 'Belarus',
  [countryCode.BE]: 'Belgium',
  [countryCode.BZ]: 'Belize',
  [countryCode.BJ]: 'Benin',
  [countryCode.BM]: 'Bermuda',
  [countryCode.BT]: 'Bhutan',
  [countryCode.BO]: 'Bolivia',
  [countryCode.BQ]: 'Bonaire, Sint Eustatius and Saba',
  [countryCode.BA]: 'Bosnia and Herzegovina',
  [countryCode.BW]: 'Botswana',
  [countryCode.BV]: 'Bouvet Island',
  [countryCode.BR]: 'Brazil',
  [countryCode.IO]: 'British Indian Ocean Territory',
  [countryCode.BN]: 'Brunei Darussalam',
  [countryCode.BG]: 'Bulgaria',
  [countryCode.BF]: 'Burkina Faso',
  [countryCode.BI]: 'Burundi',
  [countryCode.KH]: 'Cambodia',
  [countryCode.CM]: 'Cameroon',
  [countryCode.CA]: 'Canada',
  [countryCode.CV]: 'Cape Verde',
  [countryCode.KY]: 'Cayman Islands',
  [countryCode.CF]: 'Central African Republic',
  [countryCode.TD]: 'Chad',
  [countryCode.CL]: 'Chile',
  [countryCode.CN]: 'China',
  [countryCode.CX]: 'Christmas Island',
  [countryCode.CC]: 'Cocos (Keeling) Islands',
  [countryCode.CO]: 'Colombia',
  [countryCode.KM]: 'Comoros',
  [countryCode.CG]: 'Congo',
  [countryCode.CD]: 'Congo, The Democratic Republic Of The',
  [countryCode.CK]: 'Cook Islands',
  [countryCode.CR]: 'Costa Rica',
  [countryCode.CI]: "Côte D'Ivoire",
  [countryCode.HR]: 'Croatia',
  [countryCode.CU]: 'Cuba',
  [countryCode.CW]: 'Curaçao',
  [countryCode.CY]: 'Cyprus',
  [countryCode.CZ]: 'Czech Republic',
  [countryCode.DK]: 'Denmark',
  [countryCode.DJ]: 'Djibouti',
  [countryCode.DM]: 'Dominica',
  [countryCode.DO]: 'Dominican Republic',
  [countryCode.EC]: 'Ecuador',
  [countryCode.EG]: 'Egypt',
  [countryCode.SV]: 'El Salvador',
  [countryCode.GQ]: 'Equatorial Guinea',
  [countryCode.ER]: 'Eritrea',
  [countryCode.EE]: 'Estonia',
  [countryCode.ET]: 'Ethiopia',
  [countryCode.FK]: 'Falkland Islands',
  [countryCode.FO]: 'Faroe Islands',
  [countryCode.FJ]: 'Fiji',
  [countryCode.FI]: 'Finland',
  [countryCode.FR]: 'France',
  [countryCode.GF]: 'French Guiana',
  [countryCode.PF]: 'French Polynesia',
  [countryCode.TF]: 'French Southern Territories',
  [countryCode.GA]: 'Gabon',
  [countryCode.GM]: 'Gambia',
  [countryCode.GE]: 'Georgia',
  [countryCode.DE]: 'Germany',
  [countryCode.GH]: 'Ghana',
  [countryCode.GI]: 'Gibraltar',
  [countryCode.GR]: 'Greece',
  [countryCode.GL]: 'Greenland',
  [countryCode.GD]: 'Grenada',
  [countryCode.GP]: 'Guadeloupe',
  [countryCode.GU]: 'Guam',
  [countryCode.GT]: 'Guatemala',
  [countryCode.GG]: 'Guernsey',
  [countryCode.GN]: 'Guinea',
  [countryCode.GW]: 'Guinea-bissau',
  [countryCode.GY]: 'Guyana',
  [countryCode.HT]: 'Haiti',
  [countryCode.HM]: 'Heard Island and Mcdonald Islands',
  [countryCode.VA]: 'Holy See (Vatican City State)',
  [countryCode.HN]: 'Honduras',
  [countryCode.HK]: 'Hong Kong',
  [countryCode.HU]: 'Hungary',
  [countryCode.IS]: 'Iceland',
  [countryCode.IN]: 'India',
  [countryCode.ID]: 'Indonesia',
  [countryCode.IR]: 'Iran, Islamic Republic Of',
  [countryCode.IQ]: 'Iraq',
  [countryCode.IE]: 'Ireland',
  [countryCode.IM]: 'Isle Of Man',
  [countryCode.IL]: 'Israel',
  [countryCode.IT]: 'Italy',
  [countryCode.JM]: 'Jamaica',
  [countryCode.JP]: 'Japan',
  [countryCode.JE]: 'Jersey',
  [countryCode.JO]: 'Jordan',
  [countryCode.KZ]: 'Kazakhstan',
  [countryCode.KE]: 'Kenya',
  [countryCode.KI]: 'Kiribati',
  [countryCode.KP]: 'North Korea',
  [countryCode.KR]: 'Korea, Republic Of',
  [countryCode.KW]: 'Kuwait',
  [countryCode.KG]: 'Kyrgyzstan',
  [countryCode.LA]: "Lao People's Democratic Republic",
  [countryCode.LV]: 'Latvia',
  [countryCode.LB]: 'Lebanon',
  [countryCode.LS]: 'Lesotho',
  [countryCode.LR]: 'Liberia',
  [countryCode.LY]: 'Libya',
  [countryCode.LI]: 'Liechtenstein',
  [countryCode.LT]: 'Lithuania',
  [countryCode.LU]: 'Luxembourg',
  [countryCode.MO]: 'Macao',
  [countryCode.MK]: 'Macedonia, The Former Yugoslav Republic Of',
  [countryCode.MG]: 'Madagascar',
  [countryCode.MW]: 'Malawi',
  [countryCode.MY]: 'Malaysia',
  [countryCode.MV]: 'Maldives',
  [countryCode.ML]: 'Mali',
  [countryCode.MT]: 'Malta',
  [countryCode.MH]: 'Marshall Islands',
  [countryCode.MQ]: 'Martinique',
  [countryCode.MR]: 'Mauritania',
  [countryCode.MU]: 'Mauritius',
  [countryCode.YT]: 'Mayotte',
  [countryCode.MX]: 'Mexico',
  [countryCode.FM]: 'Micronesia',
  [countryCode.MD]: 'Moldova, Republic Of',
  [countryCode.MC]: 'Monaco',
  [countryCode.MN]: 'Mongolia',
  [countryCode.ME]: 'Montenegro',
  [countryCode.MS]: 'Montserrat',
  [countryCode.MA]: 'Morocco',
  [countryCode.MZ]: 'Mozambique',
  [countryCode.MM]: 'Myanmar',
  [countryCode.NA]: 'Namibia',
  [countryCode.NR]: 'Nauru',
  [countryCode.NP]: 'Nepal',
  [countryCode.NL]: 'Netherlands',
  [countryCode.NC]: 'New Caledonia',
  [countryCode.NZ]: 'New Zealand',
  [countryCode.NI]: 'Nicaragua',
  [countryCode.NE]: 'Niger',
  [countryCode.NG]: 'Nigeria',
  [countryCode.NU]: 'Niue',
  [countryCode.NF]: 'Norfolk Island',
  [countryCode.MP]: 'Northern Mariana Islands',
  [countryCode.NO]: 'Norway',
  [countryCode.OM]: 'Oman',
  [countryCode.PK]: 'Pakistan',
  [countryCode.PW]: 'Palau',
  [countryCode.PS]: 'Palestinian Territory, Occupied',
  [countryCode.PA]: 'Panama',
  [countryCode.PG]: 'Papua New Guinea',
  [countryCode.PY]: 'Paraguay',
  [countryCode.PE]: 'Peru',
  [countryCode.PH]: 'Philippines',
  [countryCode.PN]: 'Pitcairn',
  [countryCode.PL]: 'Poland',
  [countryCode.PT]: 'Portugal',
  [countryCode.PR]: 'Puerto Rico',
  [countryCode.QA]: 'Qatar',
  [countryCode.RE]: 'Réunion',
  [countryCode.RO]: 'Romania',
  [countryCode.RU]: 'Russian Federation',
  [countryCode.RW]: 'Rwanda',
  [countryCode.BL]: 'Saint Barthélemy',
  [countryCode.SH]: 'Saint Helena, Ascension and Tristan Da Cunha',
  [countryCode.KN]: 'Saint Kitts And Nevis',
  [countryCode.LC]: 'Saint Lucia',
  [countryCode.MF]: 'Saint Martin (french Part)',
  [countryCode.PM]: 'Saint Pierre And Miquelon',
  [countryCode.VC]: 'Saint Vincent and the Grenadines',
  [countryCode.WS]: 'Samoa',
  [countryCode.SM]: 'San Marino',
  [countryCode.ST]: 'Sao Tome and Principe',
  [countryCode.SA]: 'Saudi Arabia',
  [countryCode.SN]: 'Senegal',
  [countryCode.RS]: 'Serbia',
  [countryCode.SC]: 'Seychelles',
  [countryCode.SL]: 'Sierra Leone',
  [countryCode.SG]: 'Singapore',
  [countryCode.SX]: 'Sint Maarten (dutch Part)',
  [countryCode.SK]: 'Slovakia',
  [countryCode.SI]: 'Slovenia',
  [countryCode.SB]: 'Solomon Islands',
  [countryCode.SO]: 'Somalia',
  [countryCode.ZA]: 'South Africa',
  [countryCode.GS]: 'South Georgia and the South Sandwich Islands',
  [countryCode.SS]: 'South Sudan',
  [countryCode.ES]: 'Spain',
  [countryCode.LK]: 'Sri Lanka',
  [countryCode.SD]: 'Sudan',
  [countryCode.SR]: 'Suriname',
  [countryCode.SJ]: 'Svalbard and Jan Mayen',
  [countryCode.SZ]: 'Swaziland',
  [countryCode.SE]: 'Sweden',
  [countryCode.CH]: 'Switzerland',
  [countryCode.SY]: 'Syrian Arab Republic',
  [countryCode.TW]: 'Taiwan',
  [countryCode.TJ]: 'Tajikistan',
  [countryCode.TZ]: 'Tanzania, United Republic Of',
  [countryCode.TH]: 'Thailand',
  [countryCode.TL]: 'Timor-leste',
  [countryCode.TG]: 'Togo',
  [countryCode.TK]: 'Tokelau',
  [countryCode.TO]: 'Tonga',
  [countryCode.TT]: 'Trinidad And Tobago',
  [countryCode.TN]: 'Tunisia',
  [countryCode.TR]: 'Turkey',
  [countryCode.TM]: 'Turkmenistan',
  [countryCode.TC]: 'Turks and Caicos Islands',
  [countryCode.TV]: 'Tuvalu',
  [countryCode.UG]: 'Uganda',
  [countryCode.UA]: 'Ukraine',
  [countryCode.AE]: 'United Arab Emirates',
  [countryCode.GB]: 'United Kingdom',
  [countryCode.UY]: 'Uruguay',
  [countryCode.UZ]: 'Uzbekistan',
  [countryCode.VU]: 'Vanuatu',
  [countryCode.VE]: 'Venezuela, Bolivarian Republic Of',
  [countryCode.VN]: 'Viet Nam',
  [countryCode.VG]: 'Virgin Islands, British',
  [countryCode.VI]: 'Virgin Islands (U.S.)',
  [countryCode.WF]: 'Wallis And Futuna',
  [countryCode.EH]: 'Western Sahara',
  [countryCode.YE]: 'Yemen',
  [countryCode.ZM]: 'Zambia',
  [countryCode.ZW]: 'Zimbabwe'
}

export const countries = [
  { value: countryCode.US, label: countryCodeToNameMap.US },
  { value: countryCode.AF, label: countryCodeToNameMap.AF },
  { value: countryCode.AX, label: countryCodeToNameMap.AX },
  { value: countryCode.AL, label: countryCodeToNameMap.AL },
  { value: countryCode.DZ, label: countryCodeToNameMap.DZ },
  { value: countryCode.AS, label: countryCodeToNameMap.AS },
  { value: countryCode.AD, label: countryCodeToNameMap.AD },
  { value: countryCode.AO, label: countryCodeToNameMap.AO },
  { value: countryCode.AI, label: countryCodeToNameMap.AI },
  { value: countryCode.AQ, label: countryCodeToNameMap.AQ },
  { value: countryCode.AG, label: countryCodeToNameMap.AG },
  { value: countryCode.AR, label: countryCodeToNameMap.AR },
  { value: countryCode.AM, label: countryCodeToNameMap.AM },
  { value: countryCode.AW, label: countryCodeToNameMap.AW },
  { value: countryCode.AU, label: countryCodeToNameMap.AU },
  { value: countryCode.AT, label: countryCodeToNameMap.AT },
  { value: countryCode.AZ, label: countryCodeToNameMap.AZ },
  { value: countryCode.BS, label: countryCodeToNameMap.BS },
  { value: countryCode.BH, label: countryCodeToNameMap.BH },
  { value: countryCode.BD, label: countryCodeToNameMap.BD },
  { value: countryCode.BB, label: countryCodeToNameMap.BB },
  { value: countryCode.BY, label: countryCodeToNameMap.BY },
  { value: countryCode.BE, label: countryCodeToNameMap.BE },
  { value: countryCode.BZ, label: countryCodeToNameMap.BZ },
  { value: countryCode.BJ, label: countryCodeToNameMap.BJ },
  { value: countryCode.BM, label: countryCodeToNameMap.BM },
  { value: countryCode.BT, label: countryCodeToNameMap.BT },
  { value: countryCode.BO, label: countryCodeToNameMap.BO },
  { value: countryCode.BQ, label: countryCodeToNameMap.BQ },
  { value: countryCode.BA, label: countryCodeToNameMap.BA },
  { value: countryCode.BW, label: countryCodeToNameMap.BW },
  { value: countryCode.BV, label: countryCodeToNameMap.BV },
  { value: countryCode.BR, label: countryCodeToNameMap.BR },
  { value: countryCode.IO, label: countryCodeToNameMap.IO },
  { value: countryCode.BN, label: countryCodeToNameMap.BN },
  { value: countryCode.BG, label: countryCodeToNameMap.BG },
  { value: countryCode.BF, label: countryCodeToNameMap.BF },
  { value: countryCode.BI, label: countryCodeToNameMap.BI },
  { value: countryCode.KH, label: countryCodeToNameMap.KH },
  { value: countryCode.CM, label: countryCodeToNameMap.CM },
  { value: countryCode.CA, label: countryCodeToNameMap.CA },
  { value: countryCode.CV, label: countryCodeToNameMap.CV },
  { value: countryCode.KY, label: countryCodeToNameMap.KY },
  { value: countryCode.CF, label: countryCodeToNameMap.CF },
  { value: countryCode.TD, label: countryCodeToNameMap.TD },
  { value: countryCode.CL, label: countryCodeToNameMap.CL },
  { value: countryCode.CN, label: countryCodeToNameMap.CN },
  { value: countryCode.CX, label: countryCodeToNameMap.CX },
  { value: countryCode.CC, label: countryCodeToNameMap.CC },
  { value: countryCode.CO, label: countryCodeToNameMap.CO },
  { value: countryCode.KM, label: countryCodeToNameMap.KM },
  { value: countryCode.CG, label: countryCodeToNameMap.CG },
  { value: countryCode.CD, label: countryCodeToNameMap.CD },
  { value: countryCode.CK, label: countryCodeToNameMap.CK },
  { value: countryCode.CR, label: countryCodeToNameMap.CR },
  { value: countryCode.CI, label: countryCodeToNameMap.CI },
  { value: countryCode.HR, label: countryCodeToNameMap.HR },
  { value: countryCode.CU, label: countryCodeToNameMap.CU },
  { value: countryCode.CW, label: countryCodeToNameMap.CW },
  { value: countryCode.CY, label: countryCodeToNameMap.CY },
  { value: countryCode.CZ, label: countryCodeToNameMap.CZ },
  { value: countryCode.DK, label: countryCodeToNameMap.DK },
  { value: countryCode.DJ, label: countryCodeToNameMap.DJ },
  { value: countryCode.DM, label: countryCodeToNameMap.DM },
  { value: countryCode.DO, label: countryCodeToNameMap.DO },
  { value: countryCode.EC, label: countryCodeToNameMap.EC },
  { value: countryCode.EG, label: countryCodeToNameMap.EG },
  { value: countryCode.SV, label: countryCodeToNameMap.SV },
  { value: countryCode.GQ, label: countryCodeToNameMap.GQ },
  { value: countryCode.ER, label: countryCodeToNameMap.ER },
  { value: countryCode.EE, label: countryCodeToNameMap.EE },
  { value: countryCode.ET, label: countryCodeToNameMap.ET },
  { value: countryCode.FK, label: countryCodeToNameMap.FK },
  { value: countryCode.FO, label: countryCodeToNameMap.FO },
  { value: countryCode.FJ, label: countryCodeToNameMap.FJ },
  { value: countryCode.FI, label: countryCodeToNameMap.FI },
  { value: countryCode.FR, label: countryCodeToNameMap.FR },
  { value: countryCode.GF, label: countryCodeToNameMap.GF },
  { value: countryCode.PF, label: countryCodeToNameMap.PF },
  { value: countryCode.TF, label: countryCodeToNameMap.TF },
  { value: countryCode.GA, label: countryCodeToNameMap.GA },
  { value: countryCode.GM, label: countryCodeToNameMap.GM },
  { value: countryCode.GE, label: countryCodeToNameMap.GE },
  { value: countryCode.DE, label: countryCodeToNameMap.DE },
  { value: countryCode.GH, label: countryCodeToNameMap.GH },
  { value: countryCode.GI, label: countryCodeToNameMap.GI },
  { value: countryCode.GR, label: countryCodeToNameMap.GR },
  { value: countryCode.GL, label: countryCodeToNameMap.GL },
  { value: countryCode.GD, label: countryCodeToNameMap.GD },
  { value: countryCode.GP, label: countryCodeToNameMap.GP },
  { value: countryCode.GU, label: countryCodeToNameMap.GU },
  { value: countryCode.GT, label: countryCodeToNameMap.GT },
  { value: countryCode.GG, label: countryCodeToNameMap.GG },
  { value: countryCode.GN, label: countryCodeToNameMap.GN },
  { value: countryCode.GW, label: countryCodeToNameMap.GW },
  { value: countryCode.GY, label: countryCodeToNameMap.GY },
  { value: countryCode.HT, label: countryCodeToNameMap.HT },
  { value: countryCode.HM, label: countryCodeToNameMap.HM },
  { value: countryCode.VA, label: countryCodeToNameMap.VA },
  { value: countryCode.HN, label: countryCodeToNameMap.HN },
  { value: countryCode.HK, label: countryCodeToNameMap.HK },
  { value: countryCode.HU, label: countryCodeToNameMap.HU },
  { value: countryCode.IS, label: countryCodeToNameMap.IS },
  { value: countryCode.IN, label: countryCodeToNameMap.IN },
  { value: countryCode.ID, label: countryCodeToNameMap.ID },
  { value: countryCode.IR, label: countryCodeToNameMap.IR },
  { value: countryCode.IQ, label: countryCodeToNameMap.IQ },
  { value: countryCode.IE, label: countryCodeToNameMap.IE },
  { value: countryCode.IM, label: countryCodeToNameMap.IM },
  { value: countryCode.IL, label: countryCodeToNameMap.IL },
  { value: countryCode.IT, label: countryCodeToNameMap.IT },
  { value: countryCode.JM, label: countryCodeToNameMap.JM },
  { value: countryCode.JP, label: countryCodeToNameMap.JP },
  { value: countryCode.JE, label: countryCodeToNameMap.JE },
  { value: countryCode.JO, label: countryCodeToNameMap.JO },
  { value: countryCode.KZ, label: countryCodeToNameMap.KZ },
  { value: countryCode.KE, label: countryCodeToNameMap.KE },
  { value: countryCode.KI, label: countryCodeToNameMap.KI },
  { value: countryCode.KP, label: countryCodeToNameMap.KP },
  { value: countryCode.KR, label: countryCodeToNameMap.KR },
  { value: countryCode.KW, label: countryCodeToNameMap.KW },
  { value: countryCode.KG, label: countryCodeToNameMap.KG },
  { value: countryCode.LA, label: countryCodeToNameMap.LA },
  { value: countryCode.LV, label: countryCodeToNameMap.LV },
  { value: countryCode.LB, label: countryCodeToNameMap.LB },
  { value: countryCode.LS, label: countryCodeToNameMap.LS },
  { value: countryCode.LR, label: countryCodeToNameMap.LR },
  { value: countryCode.LY, label: countryCodeToNameMap.LY },
  { value: countryCode.LI, label: countryCodeToNameMap.LI },
  { value: countryCode.LT, label: countryCodeToNameMap.LT },
  { value: countryCode.LU, label: countryCodeToNameMap.LU },
  { value: countryCode.MO, label: countryCodeToNameMap.MO },
  { value: countryCode.MK, label: countryCodeToNameMap.MK },
  { value: countryCode.MG, label: countryCodeToNameMap.MG },
  { value: countryCode.MW, label: countryCodeToNameMap.MW },
  { value: countryCode.MY, label: countryCodeToNameMap.MY },
  { value: countryCode.MV, label: countryCodeToNameMap.MV },
  { value: countryCode.ML, label: countryCodeToNameMap.ML },
  { value: countryCode.MT, label: countryCodeToNameMap.MT },
  { value: countryCode.MH, label: countryCodeToNameMap.MH },
  { value: countryCode.MQ, label: countryCodeToNameMap.MQ },
  { value: countryCode.MR, label: countryCodeToNameMap.MR },
  { value: countryCode.MU, label: countryCodeToNameMap.MU },
  { value: countryCode.YT, label: countryCodeToNameMap.YT },
  { value: countryCode.MX, label: countryCodeToNameMap.MX },
  { value: countryCode.FM, label: countryCodeToNameMap.FM },
  { value: countryCode.MD, label: countryCodeToNameMap.MD },
  { value: countryCode.MC, label: countryCodeToNameMap.MC },
  { value: countryCode.MN, label: countryCodeToNameMap.MN },
  { value: countryCode.ME, label: countryCodeToNameMap.ME },
  { value: countryCode.MS, label: countryCodeToNameMap.MS },
  { value: countryCode.MA, label: countryCodeToNameMap.MA },
  { value: countryCode.MZ, label: countryCodeToNameMap.MZ },
  { value: countryCode.MM, label: countryCodeToNameMap.MM },
  { value: countryCode.NA, label: countryCodeToNameMap.NA },
  { value: countryCode.NR, label: countryCodeToNameMap.NR },
  { value: countryCode.NP, label: countryCodeToNameMap.NP },
  { value: countryCode.NL, label: countryCodeToNameMap.NL },
  { value: countryCode.NC, label: countryCodeToNameMap.NC },
  { value: countryCode.NZ, label: countryCodeToNameMap.NZ },
  { value: countryCode.NI, label: countryCodeToNameMap.NI },
  { value: countryCode.NE, label: countryCodeToNameMap.NE },
  { value: countryCode.NG, label: countryCodeToNameMap.NG },
  { value: countryCode.NU, label: countryCodeToNameMap.NU },
  { value: countryCode.NF, label: countryCodeToNameMap.NF },
  { value: countryCode.MP, label: countryCodeToNameMap.MP },
  { value: countryCode.NO, label: countryCodeToNameMap.NO },
  { value: countryCode.OM, label: countryCodeToNameMap.OM },
  { value: countryCode.PK, label: countryCodeToNameMap.PK },
  { value: countryCode.PW, label: countryCodeToNameMap.PW },
  { value: countryCode.PS, label: countryCodeToNameMap.PS },
  { value: countryCode.PA, label: countryCodeToNameMap.PA },
  { value: countryCode.PG, label: countryCodeToNameMap.PG },
  { value: countryCode.PY, label: countryCodeToNameMap.PY },
  { value: countryCode.PE, label: countryCodeToNameMap.PE },
  { value: countryCode.PH, label: countryCodeToNameMap.PH },
  { value: countryCode.PN, label: countryCodeToNameMap.PN },
  { value: countryCode.PL, label: countryCodeToNameMap.PL },
  { value: countryCode.PT, label: countryCodeToNameMap.PT },
  { value: countryCode.PR, label: countryCodeToNameMap.PR },
  { value: countryCode.QA, label: countryCodeToNameMap.QA },
  { value: countryCode.RE, label: countryCodeToNameMap.RE },
  { value: countryCode.RO, label: countryCodeToNameMap.RO },
  { value: countryCode.RU, label: countryCodeToNameMap.RU },
  { value: countryCode.RW, label: countryCodeToNameMap.RW },
  { value: countryCode.BL, label: countryCodeToNameMap.BL },
  { value: countryCode.SH, label: countryCodeToNameMap.SH },
  { value: countryCode.KN, label: countryCodeToNameMap.KN },
  { value: countryCode.LC, label: countryCodeToNameMap.LC },
  { value: countryCode.MF, label: countryCodeToNameMap.MF },
  { value: countryCode.PM, label: countryCodeToNameMap.PM },
  { value: countryCode.VC, label: countryCodeToNameMap.VC },
  { value: countryCode.WS, label: countryCodeToNameMap.WS },
  { value: countryCode.SM, label: countryCodeToNameMap.SM },
  { value: countryCode.ST, label: countryCodeToNameMap.ST },
  { value: countryCode.SA, label: countryCodeToNameMap.SA },
  { value: countryCode.SN, label: countryCodeToNameMap.SN },
  { value: countryCode.RS, label: countryCodeToNameMap.RS },
  { value: countryCode.SC, label: countryCodeToNameMap.SC },
  { value: countryCode.SL, label: countryCodeToNameMap.SL },
  { value: countryCode.SG, label: countryCodeToNameMap.SG },
  { value: countryCode.SX, label: countryCodeToNameMap.SX },
  { value: countryCode.SK, label: countryCodeToNameMap.SK },
  { value: countryCode.SI, label: countryCodeToNameMap.SI },
  { value: countryCode.SB, label: countryCodeToNameMap.SB },
  { value: countryCode.SO, label: countryCodeToNameMap.SO },
  { value: countryCode.ZA, label: countryCodeToNameMap.ZA },
  { value: countryCode.GS, label: countryCodeToNameMap.GS },
  { value: countryCode.SS, label: countryCodeToNameMap.SS },
  { value: countryCode.ES, label: countryCodeToNameMap.ES },
  { value: countryCode.LK, label: countryCodeToNameMap.LK },
  { value: countryCode.SD, label: countryCodeToNameMap.SD },
  { value: countryCode.SR, label: countryCodeToNameMap.SR },
  { value: countryCode.SJ, label: countryCodeToNameMap.SJ },
  { value: countryCode.SZ, label: countryCodeToNameMap.SZ },
  { value: countryCode.SE, label: countryCodeToNameMap.SE },
  { value: countryCode.CH, label: countryCodeToNameMap.CH },
  { value: countryCode.SY, label: countryCodeToNameMap.SY },
  { value: countryCode.TW, label: countryCodeToNameMap.TW },
  { value: countryCode.TJ, label: countryCodeToNameMap.TJ },
  { value: countryCode.TZ, label: countryCodeToNameMap.TZ },
  { value: countryCode.TH, label: countryCodeToNameMap.TH },
  { value: countryCode.TL, label: countryCodeToNameMap.TL },
  { value: countryCode.TG, label: countryCodeToNameMap.TG },
  { value: countryCode.TK, label: countryCodeToNameMap.TK },
  { value: countryCode.TO, label: countryCodeToNameMap.TO },
  { value: countryCode.TT, label: countryCodeToNameMap.TT },
  { value: countryCode.TN, label: countryCodeToNameMap.TN },
  { value: countryCode.TR, label: countryCodeToNameMap.TR },
  { value: countryCode.TM, label: countryCodeToNameMap.TM },
  { value: countryCode.TC, label: countryCodeToNameMap.TC },
  { value: countryCode.TV, label: countryCodeToNameMap.TV },
  { value: countryCode.UG, label: countryCodeToNameMap.UG },
  { value: countryCode.UA, label: countryCodeToNameMap.UA },
  { value: countryCode.AE, label: countryCodeToNameMap.AE },
  { value: countryCode.GB, label: countryCodeToNameMap.GB },
  { value: countryCode.UY, label: countryCodeToNameMap.UY },
  { value: countryCode.UZ, label: countryCodeToNameMap.UZ },
  { value: countryCode.VU, label: countryCodeToNameMap.VU },
  { value: countryCode.VE, label: countryCodeToNameMap.VE },
  { value: countryCode.VN, label: countryCodeToNameMap.VN },
  { value: countryCode.VG, label: countryCodeToNameMap.VG },
  { value: countryCode.VI, label: countryCodeToNameMap.VI },
  { value: countryCode.WF, label: countryCodeToNameMap.WF },
  { value: countryCode.EH, label: countryCodeToNameMap.EH },
  { value: countryCode.YE, label: countryCodeToNameMap.YE },
  { value: countryCode.ZM, label: countryCodeToNameMap.ZM },
  { value: countryCode.ZW, label: countryCodeToNameMap.ZW }
]
